import {MARKER} from '../utils/constants.js';
import {noop} from '../utils/utils.js';

export const label = s => `${MARKER}${s}`;

const TTI = label('tti');
const LCP = label('lcp');

export default function markAndMeasure(performance, individually, together) {
    individually
        .filter(({startTime}) => startTime > 0)
        .forEach(({entryType, startTime, duration, detail}) => {
            try {
                const name = label(entryType);
                mark(name, startTime, detail);
                measure(name, {
                    start: startTime,
                    end: startTime + duration,
                    detail
                });
            } catch (e) {
                // empty
            }
        });

    Promise.all(together)
        .then(([{['first-contentful-paint']: fcp}, {tti, tbt}, {startTime: lcp}]) => {
            mark(LCP, lcp);
            mark(TTI, tti, tbt);

            const lcpDuration = {
                end: lcp
            };
            const ttiDuration = {
                end: tti,
                detail: tbt
            };
            [lcpDuration.start, ttiDuration.start] = lcp < tti ? [fcp, lcp] : [tti, fcp];
            measure(LCP, lcpDuration);
            measure(TTI, ttiDuration);
        }, noop);

    function mark(label, startTime, detail) {
        performance.mark(label, {
            startTime,
            detail
        });
    }
    function measure(label, options) {
        performance.measure(label, options);
    }
}
